module.exports = __webpack_public_path__ + "static/img/1_IMG_20150812_140656.08af43fe.jpg";